module.exports = __webpack_public_path__ + "img/error.3a37184d.png";